<div class="loader">
  <span class="loader-ellipsis"></span>
  <span *ngIf="loaderText" class="loader-text">{{ loaderText }}</span>
</div>
